import script from "./CancelButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelButton.vue?vue&type=script&setup=true&lang=js"

import "./CancelButton.vue?vue&type=style&index=0&id=6b13ead1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b13ead1"]])

export default __exports__